// Force predictive search suggestions while typing
document.addEventListener('input', (e) => {
  const input = e.target;
  if (!input || !input.matches('input[type="search"]')) return;

  // Trigger the listeners some themes rely on
  input.dispatchEvent(new Event('change', { bubbles: true }));
  input.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true, key: input.value.slice(-1) || '' }));
});
